export default function() {
  const main_content = document.querySelector('main');
  const url_params = new URLSearchParams(window.location.search);
  // console.log(url_params.size);
  if(url_params.size > 0) {
    const highlighted_search_term = url_params.get('highlight');
    const capitalized_first_letter_search_term = capitalizeFirstLetter(highlighted_search_term);
    const title_case_search_term = toTitleCase(highlighted_search_term);

    var node = document.createElement('mark');
    node.appendChild(document.createTextNode(highlighted_search_term));
    var capitalized_first_letter_node = document.createElement('mark');
    capitalized_first_letter_node.appendChild(document.createTextNode(capitalized_first_letter_search_term));
    var title_case_node = document.createElement('mark');
    title_case_node.appendChild(document.createTextNode(title_case_search_term));
    replaceText(document.body, highlighted_search_term, node);
    replaceText(document.body, capitalized_first_letter_search_term, capitalized_first_letter_node);
    replaceText(document.body, title_case_search_term, title_case_node);
  }
}

function replaceText(node, text, replacementNodeTemplate) {
  if (node.nodeType == 3) {
      while (node) {
          var textIndex = node.data.indexOf(text), currentNode = node;
          if (textIndex == -1) {
              node = null;
          } else {
              // Split the text node after the text
              var splitIndex = textIndex + text.length;
              var replacementNode = replacementNodeTemplate.cloneNode(true);
              if (splitIndex < node.length) {
                  node = node.splitText(textIndex + text.length);
                  node.parentNode.insertBefore(replacementNode, node);
              } else {
                  node.parentNode.appendChild(replacementNode);
                  node = null;
              }
              currentNode.deleteData(textIndex, text.length);
          }
      }
  } else {
      var child = node.firstChild, nextChild;
      while (child) {
          nextChild = child.nextSibling;
          replaceText(child, text, replacementNodeTemplate);
          child = nextChild;
      }
  }
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}


function toTitleCase(str) {
  return str.replace(
    /\w\S*/g,
    text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
  );
}